import { apiClient } from "@/services/apiServices";
import axios from "axios";
import { useEffect, useState } from "react";

// Country-to-Currency mapping
const countryToCurrency: { [key: string]: string } = {
  IN: "INR", // India
  US: "USD", // USA
  CA: "INR", // CANADA FOR testing added inr
  DE: "EUR", // Germany
  FR: "EUR", // France
  GB: "GBP", // UK
  IT: "EUR", // Italy
  ES: "EUR", // Spain
  NL: "EUR", // Netherlands
  BE: "EUR", // Belgium
  AT: "EUR", // Austria
  FI: "EUR", // Finland
  IE: "EUR", // Ireland
  PT: "EUR", // Portugal
  BD: "USD", // Portugal
};
// Default currency for unsupported countries
const defaultCurrency = "INR";

// Helper function to get currency symbol
function getCurrencySymbol(currency: string): string {
  const symbols: { [key: string]: string } = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };
  return symbols[currency] || "$"; // Default to "$" if symbol is not found
}

export type TUCDT= {symbols:string,currency:string,country:string}
export const usePricingSolution = () => {
 const [ucdT, setUCDT] = useState<TUCDT| null>(null); // ucdt refers to user currency data
 
  const fetchPricingFormula = async () => {
    try {
      // Use environment variable for API token
      const response = await axios.get(
        `https://ipinfo.io/json?token=${
          import.meta.env.VITE_PUBLIC_IPINFO_TOKEN
        }`
      );

      const userCurrency: string =
        countryToCurrency[response?.data?.country] || defaultCurrency;
      const symbol = getCurrencySymbol(userCurrency) ||"$" ;

      const data = {
        country: response?.data?.country || "IN",
        currency: userCurrency,
        symbols: symbol,
      };

      localStorage.setItem("ucdt", JSON.stringify(data));
      setUCDT(data)
      console.log("set to local storage");
    } catch (err) {
     console.log(err);
    }
  };

  useEffect(() => {
    const stored = localStorage.getItem("ucdt");

    if (stored) {
      // console.log('Found from ls',stored);
      try {
        const parsed = JSON.parse(stored);
        if (parsed?.currency) {
          setUCDT(parsed);
          return;
        }
      } catch (err) {
        console.warn("Error parsing local storage data", err);
      }
    }
  console.log('Rendered');
    fetchPricingFormula();

  }, []);

  return {
    ucdT: ucdT as TUCDT
  };
};
